import { ChildId } from '../child';
import { CourseId } from '../lesson';

export type DiscountId = string & { readonly type: unique symbol };

export enum DiscountTarget {
    MEAL = 'MEALS',
    STAY = 'STAY',
    EXTRA_LESSONS = 'EXTRA_LESSONS',
    ADDITIONAL_COST = 'ADDITIONAL_COST',
    ALL_COSTS = 'ALL_COSTS',
}

export enum DiscountType {
    VALUE_DISCOUNT = 'VALUE_DISCOUNT',
    PERCENTAGE_DISCOUNT = 'PERCENTAGE_DISCOUNT',
}

export enum DiscountApplyType {
    COMPONENT = 'COMPONENT', // składowa
    CATEGORY = 'CATEGORY', // końcowa
}

export type DiscountDTO = {
    id: DiscountId;
    childId: ChildId;
    discountTarget: DiscountTarget;
    discountType: DiscountType;
    applyType: DiscountApplyType;
    name: string;
    startDate: string;
    endDate: string;
    amount: number;
    extraLessons?: {
        id: CourseId;
        name: string;
    };
};

export type AddDiscountDTO = {
    childId: ChildId;
    discountTarget: DiscountTarget;
    discountType: DiscountType;
    applyType: DiscountApplyType;
    name: string;
    amount: number;
    startDate: string;
    endDate: string;
    courseId?: CourseId;
};

export type EditDiscountDTO = Partial<Omit<AddDiscountDTO, 'discountTarget' | 'discountType'>>;
